'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const HeaderSelector = ({
  children,
  isCheckoutHeader = false,
}: {
  children: React.ReactNode;
  isCheckoutHeader?: boolean;
}) => {
  const [isMainMenu, setIsMainMenu] = useState(true);
  const pathname = usePathname();

  useEffect(() => {
    if (
      pathname?.includes('/zamowienie') ||
      pathname?.includes('/podsumowanie')
    ) {
      setIsMainMenu(false);
    } else {
      setIsMainMenu(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  if (isMainMenu && !isCheckoutHeader) {
    return <>{children}</>;
  }

  if (!isMainMenu && isCheckoutHeader) {
    return <>{children}</>;
  }

  return null;
};

export default HeaderSelector;
